export default __webpack_public_path__ + "static/media/August_08.fbc9177b.png";